import React from 'react'
import { forumMutations } from '../../graphql/mutations'
import { useMutation } from '@apollo/react-hooks'
import { useSnackbar } from 'notistack'
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'
import { useHistory } from 'react-router-dom'
import { isModerator } from '../../services/auth'

const DeleteButton = ({ topico_id, resposta_id, query }) => {
  const { enqueueSnackbar } = useSnackbar()
  const history = useHistory()
  const [deletaTopicoForum] = useMutation(forumMutations.DELETA_TOPICO, {
    onCompleted: () => {
      enqueueSnackbar('Tópico deletado com sucesso.')
      history.push(`/forum`)
      window.location.reload()
    }
  })
  const [deletaRespostaTopicoForum] = useMutation(forumMutations.DELETA_RESPOSTA_TOPICO, {
    onCompleted: () => {
      enqueueSnackbar('Resposta deletada com sucesso.')
      window.location.reload()
    }
  })

  const handleDelete = () => {
    if (resposta_id) {
      if (window.confirm('Confirma a exclusão desta resposta?')) {
        deletaRespostaTopicoForum({ variables: { _id: resposta_id } })
      }
    } else {
      if (window.confirm('Confirma a exclusão deste tópico?')) {
        deletaTopicoForum({ variables: { _id: topico_id } })
      }
    }
  }

  return isModerator() ? (
    <IconButton aria-label="delete" onClick={handleDelete}>
      <DeleteIcon />
    </IconButton>
  ) : null
}

export default DeleteButton
